import CitySEOHead from "@/components/feature/CitySEOHead";
import PompanoHeroSection from "./components/HeroSection";
import PompanoStickyNav from "./components/StickyNav";
import PompanoProcessingTimeSection from "./components/ProcessingTimeSection";
import PompanoServicesSection from "./components/ServicesSection";
import PompanoLocalAreaSection from "./components/LocalAreaSection";
import PompanoTestimonialsSection from "./components/TestimonialsSection";
import PompanoAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PompanoComparisonSection from "./components/ComparisonSection";
import PompanoMistakesSection from "./components/MistakesSection";
import PompanoHowItWorksSection from "./components/HowItWorksSection";
import PompanoFAQSection from "./components/FAQSection";
import PompanoHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PompanoFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Pompano Beach, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Pompano Beach, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Broward County travelers.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const faqs = [
  {
    q: "Where can I get an emergency passport in Pompano Beach today?",
    a: "For same-day emergency passport needs in Pompano Beach, you have two primary options. The Miami Passport Agency (1501 Biscayne Blvd Suite 210, Miami, FL 33132) is approximately 35 miles away via I-95 — about 40 minutes. Appointments are required and are typically reserved for life-or-death emergencies with documented proof of travel within 72 hours. Alternatively, Fast Passport Center can process your passport in as little as 2–3 business days through our registered courier channel — no drive to Miami, no appointment required. Start your order online and we will confirm your timeline based on your travel date.",
  },
  {
    q: "What is the fastest way to get a passport in Pompano Beach?",
    a: "The fastest option for most Pompano Beach residents is Fast Passport Center's registered courier service. We submit your application through reserved daily agency slots and deliver your new passport within 2–9 business days depending on the service level you select. This is significantly faster than the Miami Passport Agency's appointment-only process, which requires a 40-minute drive via I-95 plus an all-day wait at the agency. Standard government processing through a Pompano Beach post office takes 1–3 months. Start your order online and we will confirm the fastest available option for your travel date.",
  },
  {
    q: "Can I get a same-day passport in Pompano Beach?",
    a: "Same-day passport service is only available through a regional passport agency with an in-person appointment. The nearest regional agency to Pompano Beach is the Miami Passport Agency — approximately 35 miles via I-95 (about 40 minutes). The agency only serves travelers with life-or-death emergencies and documented travel within 72 hours. Appointments are extremely limited and must be secured through the NPIC scheduling system. Walk-ins are never accepted. For most Pompano Beach travelers who do not qualify for a same-day agency appointment, Fast Passport Center's 2–3 business day service is the fastest available option.",
  },
  {
    q: "Is there a passport agency in Pompano Beach?",
    a: "No, there is no regional passport agency in Pompano Beach. The nearest regional passport agency is the Miami Passport Agency, located at 1501 Biscayne Blvd Suite 210, Miami, FL 33132 — approximately 35 miles from Pompano Beach via I-95. Pompano Beach does have several passport acceptance facilities including USPS post offices, but these are acceptance facilities only — they process standard applications that take 1–3 months. For expedited service, Fast Passport Center's registered courier channel provides the fastest available option.",
  },
  {
    q: "What if I can't get a Pompano Beach passport agency appointment?",
    a: "If you cannot get an appointment at the Miami Passport Agency — which is common, as appointments are routinely booked 2–4 weeks out — Fast Passport Center is your most reliable alternative. Our registered courier service bypasses the appointment system entirely. We submit applications through reserved daily agency access and process passports in as little as 2–3 business days. You do not need an appointment, you do not need to drive 35 miles to Miami via I-95, and you do not need documented proof of emergency travel. Simply start your order online, visit a local Pompano Beach acceptance facility, and ship your documents overnight. We handle the rest.",
  },
];

export default function PompanoBeachPage() {
  return (
    <>
      <CitySEOHead
        city="Pompano Beach"
        state="Florida"
        stateAbbr="FL"
        route="/cities/pompano-beach"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Pompano Beach, Florida"
        geoPosition="26.2379;-80.1248"
        keywords="expedited passport Pompano Beach, emergency passport Pompano Beach FL, same day passport Pompano Beach, fast passport Broward County, passport renewal Pompano Beach, Pompano Beach passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
      />
      <div className="min-h-screen bg-white">
        <PompanoHeroSection />
        <PompanoStickyNav />
        <PompanoProcessingTimeSection />
        <PompanoServicesSection />
        <PompanoLocalAreaSection />
        <PompanoTestimonialsSection />
        <PompanoAcceptanceFacilitiesSection />
        <PompanoComparisonSection />
        <PompanoMistakesSection />
        <PompanoHowItWorksSection />
        <PompanoFAQSection />
        <PompanoHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/pompano-beach" state="FL" />
        <PompanoFinalCTA />
      </div>
    </>
  );
}